import { render, staticRenderFns } from "./LSuccessDialog.vue?vue&type=template&id=b13c6442&scoped=true"
import script from "./LSuccessDialog.vue?vue&type=script&lang=js"
export * from "./LSuccessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13c6442",
  null
  
)

export default component.exports